import script from "./media-page.vue?vue&type=script&setup=true&lang=js"
export * from "./media-page.vue?vue&type=script&setup=true&lang=js"

import "./media-page.vue?vue&type=style&index=0&id=d23779c8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d23779c8"]])

export default __exports__